import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterType: {
    startDate: "",
    endDate: "",
    refundType: "",
    paymentType: "",
  },
  page: 1,
  limit: 10,
};

const refundListSlice = createSlice({
  name: "refundList",
  initialState,
  reducers: {
    setFilterType: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    clearFilter: (state) => {
      state.filterType = {
        startDate: "",
        endDate: "",
        refundType: "",
        paymentType: "",
      };
      state.page = 1;
      state.limit = 10;
    },
  },
});

export const { setPage, setLimit, setFilterType, clearFilter } =
  refundListSlice.actions;
export default refundListSlice.reducer;
